import { create } from 'zustand';
import { ToastData } from '../components/Toast';

interface ToastStore {
  toasts: ToastData[];
  showToast: (toast: Omit<ToastData, 'id'>) => void;
  removeToast: (id: string) => void;
  clearAllToasts: () => void;
}

export const useToastStore = create<ToastStore>(set => ({
  toasts: [],

  showToast: toast => {
    const id = Math.random().toString(36).substr(2, 9);
    const newToast: ToastData = {
      ...toast,
      id,
      duration: toast.duration || 5000,
    };

    set(state => ({
      toasts: [...state.toasts, newToast],
    }));
  },

  removeToast: id => {
    set(state => ({
      toasts: state.toasts.filter(toast => toast.id !== id),
    }));
  },

  clearAllToasts: () => {
    set({ toasts: [] });
  },
}));
